
// // import React from 'react';
// // import { Grid, Paper, Typography, Button, Box } from '@mui/material';
// // import { styled } from '@mui/system';
// // import PropTypes from 'prop-types';
// // import { Link } from 'react-router-dom';


// // const StyledPaper = styled(Paper)(({ theme }) => ({
// //     padding: theme.spacing(2),
// //     display: 'flex',
// //     flexDirection: 'column',
// //     alignItems: 'flex-start',
// //     textAlign: 'left',
// //     border: 'none',
// //     boxShadow: theme.shadows[0],
// //     width: '100%',
// //     maxWidth: '332px',
// // }));

// // const Image = styled('img')({
// //     width: '100%',
// //     height: 'auto',
// //     maxWidth: '332px',
// // });

// // const Title = styled(Typography)(({ theme }) => ({

// //     fontWeight: 700,
// //     fontSize: '24px',
// //     lineHeight: '36px',
// //     margin: '1rem 0',
// //     width: '400%',
// //     [theme.breakpoints.down('sm')]: {
// //         width: '100%', // Width for mobile screens
// //         fontSize: '20px',
// //     },
// //     [theme.breakpoints.down('md')]: {
// //         width: '100%', // Width for mobile screens
// //     },
// // }));

// // const BlogDate = styled(Typography)({

// //     fontWeight: 400,
// //     fontSize: '16px',
// //     lineHeight: '20.83px',
// //     margin: '1rem 0',
// //     width: '400%',
// // });

// // const Content = styled(Typography)(({ theme }) => ({
// //     fontWeight: 400,
// //     fontSize: '16px',
// //     lineHeight: '20.83px',
// //     textAlign: 'justify',
// //     width: '415%', // Default width for larger screens
// //     marginBottom: '1rem',
// //     overflow: 'hidden',
// //     display: '-webkit-box',
// //     WebkitBoxOrient: 'vertical',
// //     WebkitLineClamp: 6,
// //     [theme.breakpoints.down('sm')]: {
// //         width: '100%', // Width for mobile screens
// //     },
// //     [theme.breakpoints.down('md')]: {
// //         width: '100%', // Width for mobile screens
// //     },
// // }));

// // const ReadMoreButton = styled(Button)({
// //     width: '50%',
// //     maxWidth: '182px',
// //     height: '2.7rem',
// //     borderRadius: '1.5rem',
// //     border: '2px solid',
// //     borderColor: '#000',
// //     alignSelf: 'flex-start',
// //     marginTop: '1rem',
// // });

// // const truncateContent = (text, maxLength) => {
// //     if (text.length <= maxLength) return text;
// //     return text.substring(0, maxLength) + '...';
// // };




// // const BlogMiniCard = ({ id, image, title, blogDate, content }) => (


// //     <Grid item xs={12} sm={12} md={4} mb={2}>
// //         <StyledPaper>
// //             <Box sx={{ width: '100%' }}>
// //                 <Box >
// //                     <img width='332px' height='257px' src={`${process.env.PUBLIC_URL}/blogImages/${id}.jpg`} alt={title} />

// //                 </Box>

// //                 <Box sx={{ width: '100%' }}>
// //                     <Title>{title}</Title>
// //                     <BlogDate> {blogDate}</BlogDate>


// //                     <Content   >{truncateContent(content, 200)}</Content>



// //                 </Box>

// //                 <Button
// //                     component={Link}
// //                     to={`/blog/${id}`}
// //                     variant="contained"
// //                     sx={{
// //                         backgroundColor: 'white',
// //                         color: 'black', // Adjust this based on your preferred text color
// //                         border: '2px solid black',
// //                         marginTop: '5px',
// //                         '&:hover': {
// //                             backgroundColor: 'primary', // A slightly darker white for the hover state
// //                             color: 'white',
// //                             border: '2px solid white',
// //                         },

// //                     }}
// //                 >
// //                     Continue Reading
// //                 </Button>



// //                 {/* <ReadMoreButton
// //                     component={Link}
// //                     to={`/blog/${id}`}
// //                     variant="contained"
// //                     color="primary"
// //                     style={{ marginTop: '10px' }}
// //                 >
// //                     Continue Reading
// //                 </ReadMoreButton> */}
// //             </Box>
// //         </StyledPaper>

// //     </Grid >
// // );

// // BlogMiniCard.propTypes = {
// //     id: PropTypes.number.isRequired,
// //     image: PropTypes.string.isRequired,
// //     title: PropTypes.string.isRequired,
// //     blogDate: PropTypes.string.isRequired,
// //     content: PropTypes.string.isRequired,
// // };

// // export default BlogMiniCard;
// import React from 'react';
// import { Grid, Paper, Typography, Button, Box } from '@mui/material';
// import { styled } from '@mui/system';
// import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';

// const StyledPaper = styled(Paper)(({ theme }) => ({
//     padding: theme.spacing(2),
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'flex-start',
//     textAlign: 'left',
//     border: 'none',
//     boxShadow: theme.shadows[0],
//     width: '100%',
//     maxWidth: '332px',
// }));

// const Image = styled('img')({
//     width: '100%',
//     height: 'auto',
//     maxWidth: '100%',
// });

// const Title = styled(Typography)(({ theme }) => ({
//     fontWeight: 700,
//     fontSize: '24px',
//     lineHeight: '36px',
//     margin: '1rem 0',
//     width: '100%', // Ensure full width on mobile
//     [theme.breakpoints.down('sm')]: {
//         fontSize: '20px',
//     },
// }));

// const BlogDate = styled(Typography)({
//     fontWeight: 400,
//     fontSize: '16px',
//     lineHeight: '20.83px',
//     margin: '1rem 0',
//     width: '100%', // Ensure full width on mobile
// });

// const Content = styled(Typography)(({ theme }) => ({
//     fontWeight: 400,
//     fontSize: '16px',
//     lineHeight: '20.83px',
//     textAlign: 'justify',
//     width: '100%', // Ensure full width on mobile
//     marginBottom: '1rem',
//     overflow: 'hidden',
//     display: '-webkit-box',
//     WebkitBoxOrient: 'vertical',
//     WebkitLineClamp: 6,
//     [theme.breakpoints.down('sm')]: {
//         fontSize: '14px', // Adjust font size for smaller screens
//     },
// }));

// const ReadMoreButton = styled(Button)({
//     width: '100%', // Full width for mobile
//     maxWidth: '182px',
//     height: '2.7rem',
//     borderRadius: '1.5rem',
//     border: '2px solid',
//     borderColor: '#000',
//     alignSelf: 'flex-start',
//     marginTop: '1rem',
// });

// const truncateContent = (text, maxLength) => {
//     if (text.length <= maxLength) return text;
//     return text.substring(0, maxLength) + '...';
// };

// const BlogMiniCard = ({ id, image, title, blogDate, content }) => (
//     <Grid item xs={12} sm={6} md={4} mb={2}>
//         <StyledPaper>
//             <Box sx={{ width: '100%' }}>
//                 <Image src={`${process.env.PUBLIC_URL}/blogImages/${id}.jpg`} alt={title} />

//                 <Box sx={{ width: '100%' }}>
//                     <Title>{title}</Title>
//                     <BlogDate>{blogDate}</BlogDate>
//                     <Content>{truncateContent(content, 200)}</Content>
//                 </Box>

//                 <ReadMoreButton
//                     component={Link}
//                     to={`/blog/${id}`}
//                     variant="contained"
//                     sx={{
//                         backgroundColor: 'white',
//                         color: 'black', // Adjust this based on your preferred text color
//                         border: '2px solid black',
//                         '&:hover': {
//                             backgroundColor: 'black', // Darker background for hover
//                             color: 'white',
//                             border: '2px solid white',
//                         },
//                     }}
//                 >
//                     Continue Reading
//                 </ReadMoreButton>
//             </Box>
//         </StyledPaper>
//     </Grid>
// );

// BlogMiniCard.propTypes = {
//     id: PropTypes.number.isRequired,
//     image: PropTypes.string.isRequired,
//     title: PropTypes.string.isRequired,
//     blogDate: PropTypes.string.isRequired,
//     content: PropTypes.string.isRequired,
// };

// export default BlogMiniCard;
import React from 'react';
import { Paper, Typography, Button, Box } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AMITASOFT_BRAND } from '../../theme/amitasoftBrand';
import { AMITASOFT_TYPO, readMoreButtonSx } from '../../theme/amitasoftTypography';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    borderRadius: theme.spacing(2),
    border: `1px solid ${AMITASOFT_BRAND.footerBorder}`,
    overflow: 'hidden',
    boxShadow: '0 4px 18px rgba(106, 138, 255, 0.07)',
    width: '100%',
    height: '100%',
}));

const ImageShell = styled(Box)(({ theme }) => ({
    width: '100%',
    paddingTop: theme.spacing(1.25),
    paddingLeft: theme.spacing(1.25),
    paddingRight: theme.spacing(1.25),
    [theme.breakpoints.up('sm')]: {
        paddingTop: theme.spacing(1.5),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
    },
}));

const ImageInner = styled(Box)(({ theme }) => ({
    width: '100%',
    aspectRatio: '16 / 10',
    overflow: 'hidden',
    borderRadius: theme.spacing(1.5),
    backgroundColor: AMITASOFT_BRAND.blogCardImageBg,
}));

const Image = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    display: 'block',
});

const Title = styled(Typography)(() => ({
    ...AMITASOFT_TYPO.cardTitle,
    fontFamily: AMITASOFT_TYPO.fontFamily,
    width: '100%',
    color: AMITASOFT_BRAND.deepPurple,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
}));

const BlogDate = styled(Typography)(() => ({
    fontWeight: 400,
    ...AMITASOFT_TYPO.bodySm,
    fontFamily: AMITASOFT_TYPO.fontFamily,
    width: '100%',
    color: AMITASOFT_BRAND.textMuted,
}));

const Content = styled(Typography)(() => ({
    fontWeight: 400,
    ...AMITASOFT_TYPO.cardBody,
    fontFamily: AMITASOFT_TYPO.fontFamily,
    textAlign: 'left',
    width: '100%',
    color: AMITASOFT_BRAND.textMuted,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 4,
}));

const ReadMoreButton = styled(Button)(() => ({
    flexShrink: 0,
}));

const truncateContent = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
};

const BlogMiniCard = ({ slug, image, imageAlt, title, blogDate, description }) => (
    <StyledPaper>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
            <ImageShell>
                <ImageInner>
                    <Image src={`${process.env.PUBLIC_URL}${image}`} alt={imageAlt || title} />
                </ImageInner>
            </ImageShell>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    width: '100%',
                    minWidth: 0,
                    px: { xs: 2, sm: 2.25, md: 2.5 },
                    pt: 1.75,
                    pb: 2,
                    gap: 1.25,
                }}
            >
                <Title>{title}</Title>
                {blogDate && <BlogDate>{blogDate}</BlogDate>}
                <Content sx={{ flex: 1 }}>{truncateContent(description, 140)}</Content>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        mt: 'auto',
                        pt: 0.5,
                    }}
                >
                    <ReadMoreButton
                        component={Link}
                        to={`/blog/${slug}/`}
                        variant="contained"
                        sx={readMoreButtonSx}
                    >
                        Continue Reading
                    </ReadMoreButton>
                </Box>
            </Box>
        </Box>
    </StyledPaper>
);

BlogMiniCard.propTypes = {
    slug: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    imageAlt: PropTypes.string,
    title: PropTypes.string.isRequired,
    blogDate: PropTypes.string,
    description: PropTypes.string.isRequired,
};

export default BlogMiniCard;
